/**
 * Как поставить приложение на домашний экран iPhone.
 *
 * Зачем экран вообще есть. Приложение живёт в двух видах: Mini App внутри
 * Telegram и обычный сайт, который iOS умеет поставить ярлыком на домашний
 * экран. Второй вид лучше: он открывается с первого экрана телефона, не
 * требует искать чат, не закрывается вместе с Telegram и не отдаёт
 * полэкрана чужому интерфейсу. Но поставить его в одно нажатие нельзя —
 * Apple не даёт сайту установить себя сам, и весь путь человек проходит
 * руками. Значит, путь надо честно расписать.
 *
 * ПОЧЕМУ ПОРЯДОК ИМЕННО ТАКОЙ. Сначала ярлык, потом вход — и это не
 * придирка. Ссылка из бота одноразовая: открыв её в браузере Telegram или
 * в Safari, человек её погасит, а ярлык на домашнем экране про этот вход
 * не узнает — iOS держит для установленного веб-приложения отдельное
 * хранилище. Поставив ярлык первым и войдя уже внутри него, человек тратит
 * ровно одну ссылку.
 */

import { useNavigate } from 'react-router-dom'

/** Адрес, который человек набирает в Safari. */
const PUBLIC_URL = 'app.regymo.ru'

interface Step {
  title: string
  detail?: string
}

const STEPS: Step[] = [
  {
    title: `Открой Safari и набери ${PUBLIC_URL}`,
    detail:
      'Именно Safari, а не браузер внутри Telegram: ярлык на домашний экран умеет ставить только он. Входить пока не нужно — приложение откроется и попросит вход, это нормально.',
  },
  {
    title: 'Нажми «Поделиться» — квадрат со стрелкой вверх',
    detail: 'Он внизу экрана, в середине панели Safari.',
  },
  {
    title: 'Выбери «На экран „Домой“» и нажми «Добавить»',
    detail: 'Значок появится на домашнем экране рядом с обычными приложениями.',
  },
  {
    title: 'Открой значок с домашнего экрана',
    detail: 'Приложение откроется на весь экран, без адресной строки Safari.',
  },
  {
    title: 'В Telegram напиши боту /login',
    detail:
      'Он пришлёт ссылку для входа. НЕ нажимай на неё: она одноразовая, и открытая в Telegram она сгорит зря. Нажми и удерживай, затем «Скопировать».',
  },
  {
    title: 'Вернись в приложение и вставь ссылку в поле входа',
    detail:
      'Поле на экране «Нужен вход». После этого вход держится полгода — каждый раз повторять не придётся.',
  },
]

export default function Install() {
  const navigate = useNavigate()

  return (
    <div className="screen">
      <h1>Приложение на домашнем экране</h1>
      <p className="muted">
        Чтобы открывать тренировку с первого экрана телефона, а не искать чат в Telegram.
      </p>
      {/* Не рекламная строка, а объяснение поведения, которое иначе выглядит
          поломкой. Safari чистит данные сайта, если им не пользовались неделю,
          и человек, заходящий через браузер от случая к случаю, будет
          регулярно получать «нужен вход». На ярлык это правило не
          распространяется. */}
      <p className="faint">
        Ещё одна причина: Safari стирает данные сайта, если не открывать его неделю, —
        и вход придётся повторять. Ярлык под это правило не попадает.
      </p>

      <ol className="install-steps">
        {STEPS.map((step, index) => (
          <li key={step.title}>
            <div className="install-title">
              <span className="install-num tnum">{index + 1}</span>
              {step.title}
            </div>
            {step.detail && <div className="faint install-detail">{step.detail}</div>}
          </li>
        ))}
      </ol>

      <div className="card tight">
        <b>Если что-то пошло не так</b>
        <ul className="tq-list" style={{ marginTop: 8 }}>
          <li>
            Нет пункта «На экран „Домой“» — значит открыт не Safari, а встроенный
            браузер. Набери адрес прямо в Safari, как в первом шаге.
          </li>
          <li>
            Ссылка перестала работать — она живёт минуты и срабатывает один раз. Попроси
            новую командой /login.
          </li>
          <li>
            Ярлык просит вход после обновления телефона — вставь новую ссылку, данные
            тренировок от этого не теряются: они на сервере.
          </li>
        </ul>
      </div>

      <div className="faint" style={{ marginTop: 14 }}>
        На Android то же самое делается в Chrome: меню «⋮» → «Установить приложение».
      </div>

      {/* На корень, а не «назад»: экран открывают и по прямой ссылке, где
          истории нет вовсе, и `navigate(-1)` там не делает ничего. */}
      <button className="btn wide" style={{ marginTop: 16 }} onClick={() => navigate('/')}>
        ← Назад
      </button>
    </div>
  )
}
